<?php

Namespace Controller ;

class UserAccountController extends \Controller\Base {

    public function execute($pageVars) {
        $page_model = new \Model\UserAccount\PageModel() ;
        $page = $page_model->getPage($pageVars) ;
        $default_page_model = new \Model\DefaultModule\PageModel() ;
        \ISOPHP\js_core::$console->log('UserAccount control pagevars', $pageVars) ;
//        \ISOPHP\js_core::$window->document->title = $page['title'] ;
        $res = new \Controller\Result() ;

        if ($pageVars['route']['action'] == 'show-interviews') {
            \ISOPHP\js_core::$console->log('Here at Show Interviews', $pageVars) ;
            $res->page = $page ;
            $res->view = 'UserAccount.php' ;
            $res->type = 'view' ;
            $res->view_control = 'UserAccount' ;
            $res->post_template = array();
            $res->post_template[] = $page_model->showInterviewList($pageVars);
            $res->post_template[] = $page_model->showLastLogin($pageVars);
            $res->post_template[] = $page_model->bindButtons() ;
            $res->post_template[] = $default_page_model->bindMenu() ;
            \ISOPHP\js_core::$console->log('UserAccount Con show interviews action', $res) ;
            return $res ;
        }

        /*if ($pageVars['route']['action'] == 'attempt') {
            $data = $page_model->getUserAccountResult($pageVars) ;
            \ISOPHP\js_core::$console->log('UserAccount Controller Attempt Result', $data) ;
            $res->type = null ; # no type means no further action
            \ISOPHP\js_core::$console->log('UserAccount Con attempt action', $res) ;
            return $res ;
        } else if ($pageVars['route']['action'] == 'dmdcards'){
            $res->page = $page ;
            $res->view = 'UserAccountDMDCards.php' ;
            $res->type = 'view' ;
            $res->view_control = 'UserAccount' ;
            $res->post_template = array() ;
            $res->post_template[] = $page_model->showCardOptions($pageVars, 'virtual') ;
            $res->post_template[] = $page_model->showCardOptions($pageVars, 'plastic') ;
            $res->post_template[] = $page_model->bindDMDButtons($pageVars) ;
            $res->post_template[] = $page_model->bindGenericButtons() ;
            $res->post_template[] = $default_page_model->bindMenu() ;
            \ISOPHP\js_core::$console->log('UserAccount Con dms cards action', $res) ;
            return $res ;
        } else if ($pageVars['route']['action'] == 'profile'){
            $res->page = $page ;
            $res->view = 'UserAccountProfile.php' ;
            $res->type = 'view' ;
            $res->view_control = 'UserAccount' ;
            $res->post_template = array() ;
            $res->post_template[] = $page_model->bindProfileButtons($pageVars) ;
            $res->post_template[] = $page_model->bindGenericButtons() ;
            $res->post_template[] = $default_page_model->bindMenu() ;
            \ISOPHP\js_core::$console->log('UserAccount Con profile action', $res) ;
            return $res ;
        }*/
    }

}


// WEBPACK FOOTER //
// app/UserAccount/Controller/UserAccountController.php